module.exports = __webpack_public_path__ + "down_pointer.png?a9bfb7715a7d193f5e2731bfc2fbb971";